import { Button } from "@mui/material"
import { navigate } from "lib/routes/navigate"

export function ClientLink({ client }) {
    return (
        <Button
            variant="outlined"
            onClick={() => {
                navigate(`app/sfg20-admin/clients/${client._id.split(":")[0]}`)
            }}
        >
            View
        </Button>
    )
}
